// extracted by mini-css-extract-plugin
export var clauseRow = "_fx-6";
export var emptyState = "_fx-d";
export var filterContent = "_fx-a";
export var filterGroup = "_fx-1";
export var filterGroupContainer = "_fx-0";
export var nestedGroup = "_fx-2";
export var nestedGroupContent = "_fx-b";
export var nestedGroupDepth1 = "_fx-3";
export var nestedGroupDepth2 = "_fx-4";
export var nestedGroupDepth3 = "_fx-5";
export var nestedGroupEmpty = "_fx-c";
export var operatorAnd = "_fx-8";
export var operatorOr = "_fx-9";
export var operatorToggle = "_fx-7";
export var removeGroupButton = "_fx-e";